import React, { useEffect } from 'react';
import { ArrowLeft, Clock } from 'iconsax-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as AddressIcon } from '../../../Assets/Icons/addressIcon.svg';
import { ReactComponent as Bed } from '../../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../../Assets/Icons/toiletIcon.svg';
import { User } from '../../../Storeredux/constants/actionTypes';
// import { ObjectType } from '../../../Services/constant/serviceType';
import { useEmployee } from '../../../Services/hooks/employee';
import Loader from '../../../Components/Loader/Loader';

function EmployeeProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  let pageName: string = location.pathname;
  pageName = pageName.split('/').pop() ?? '';
  console.log(pageName);

  const { getIndividualEmployee, eachEmployee, loading, eachEmployeeTransaction } = useEmployee();
  // const [history] = useState<ObjectType[]>([
  //   {
  //     sn: 1,
  //     employeeName: 'John Doe',
  //     employeeEmail: 'johndoe@example.com',
  //     amountLeft: 'Full-Time',
  //     amountPerMonth: '$5,000',
  //   },
  //   {
  //     sn: 2,
  //     employeeName: 'Jane Smith',
  //     employeeEmail: 'janesmith@example.com',
  //     amountLeft: 'Part-Time',
  //     amountPerMonth: '$3,000',
  //   },
  //   {
  //     sn: 3,
  //     employeeName: 'Chris Johnson',
  //     employeeEmail: 'chrisjohnson@example.com',
  //     amountLeft: 'Contract',
  //     amountPerMonth: '$4,500',
  //   },
  //   {
  //     sn: 4,
  //     employeeName: 'Anna Lee',
  //     employeeEmail: 'annalee@example.com',
  //     amountLeft: 'Intern',
  //     amountPerMonth: '$1,500',
  //   },
  // ]);

  useEffect(() => {
    if (pageName) {
      getIndividualEmployee(pageName);
    }
  }, []);

  return (
    <div className='py-10'>
    <div className='w-11/12 mx-auto'>
      <div className='flex items-center gap-2 p-3 cursor-pointer bg-custom-button-green rounded-full w-fit'>
        <ArrowLeft size="32" color="#000000" onClick={() => navigate(-1)}/>
      </div>
      <div className='rounded-3xl mx-auto px-3 py-6 md:px-5 '>
        <div className={'pb-6'}>
          <h1 className={'text-xl font-bold'}>{eachEmployee?.user?.name} Profile History</h1>
          <p className={'text-sm font-light py-2'}>Stay up-to-date with your {eachEmployee?.user?.name.split(' ')[0] || 'Employee'} rental journey and property
            interactions.</p>
        </div>

        <div className={'bg-white py-6 px-6 flex flex-col gap-y-4 border border-custom-grey lg:w-[30%] w-[50%]'} style={{
          boxShadow: '0px 2px 10px 0px #0000001A',
        }}>
          {
            loading ?
              <div className="flex flex-col justify-center items-center w-full py-7">
                <Loader />
              </div> :

              eachEmployee?.property?.length !== 0 ?
                <>
                  <p className={'text-sm font-bold capitalize'}>employee Staff ID: <span>1234567890</span></p>
                  <div className={'flex text-xs font-bold items-center gap-3'}>
                    <AddressIcon className={'h-6 w-6'} />
                    <p>26 , Ogunleye Street Surulere Lagos</p>
                  </div>
                  <div className={'flex gap-3'}>
                    <div className={'flex gap-1 items-center'}>
                      <Bed className={'w-4 h-4'} />
                      <p className={'text-xs font-bold'}>4 Bedrooms</p>
                    </div>
                    <div className={'flex gap-1 items-center'}>
                      <Shower className={'w-4 h-4'} />
                      <p className={'text-xs font-bold'}>5 Baths</p>
                    </div>
                    <div className={'flex gap-1 items-center'}>
                      <Toilet className={'w-4 h-4'} />
                      <p className={'text-xs font-bold'}>2 Toilets</p>
                    </div>
                  </div>
                </> :
                <p>No Active property</p>
          }

        </div>

        <div className="my-6">
          <div className=" py-2 border border-custom-grey rounded-custom bg-white"
               style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
            <div className={'flex justify-between items-center py-6 px-3.5'}>
              <h1 className="">
                Transaction History
              </h1>
              <div className={'flex gap-3'}>
                <button
                  className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                  <Clock size="22" color="#20996B" />
                  Filter By Date
                </button>
                <button
                  className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                  <Clock size="22" color="#20996B" />
                  Export
                </button>
              </div>
            </div>
            <table className="w-full">
              <thead className="font-semibold text-xs bg-custom-light-green uppercase">
              <tr className="text-left">
                <th className="py-4 px-4">S/N</th>
                <th className={'md:table-cell hidden'}>Employee Name</th>
                <th>Debit date</th>
                <th>amount  paid</th>
                <th>amount  Left</th>
                <th>Month</th>
              </tr>
              </thead>

              {
                loading ? (
                    <tbody>
                    <tr>
                      <td colSpan={10} className="py-5 px-2">
                        <div className="flex flex-col justify-center items-center w-full py-16">
                          <Loader />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                ) :
                  eachEmployeeTransaction.length !== 0 ?
                    <tbody>
                    {
                      eachEmployeeTransaction.map((historyData: User, index: any) =>
                        <tr key={index}
                            className="font-semibold text-xxs sm:text-xs uppercase border-b-2 border-custom-light-green">
                          <td className="py-4 px-4">{historyData?.sn}</td>
                          <td className={'md:table-cell hidden'}>{historyData?.employeeName}</td>
                          <td>{historyData?.employeeEmail}</td>
                          <td>{historyData?.amountPerMonth}</td>
                          <td>{historyData?.amountLeft}</td>
                          <td>{historyData?.amountLeft}</td>
                        </tr>,
                      )
                    }
                    </tbody>
                    :
                    <tbody>
                    <tr>
                      <td colSpan={6} className="">
                        <div className="flex flex-col justify-center items-center w-full py-16">
                          <p className="text-sm pt-1">No Transaction Yet  </p>
                        </div>
                      </td>
                    </tr>
                    </tbody>
              }

            </table>
          </div>
        </div>


      </div>
    </div>
    </div>
  )
  ;
}

export default EmployeeProfile;
